(() => {
  function init(root = document) {
    root.querySelectorAll('.bm-gallery-section').forEach(section => {
      if (section.dataset.bmBound) return;
      section.dataset.bmBound = 'true';
      const buttons = section.querySelectorAll('[data-bm-filter]');
      const filter = key => {
        if (![...buttons].some(b => b.dataset.bmFilter === key)) key = 'all';
        buttons.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.bmFilter === key)));
        let count = 0;
        section.querySelectorAll('[data-bm-category]').forEach(card => {
          card.hidden = key !== 'all' && card.dataset.bmCategory !== key;
          if (!card.hidden) count++;
        });
        const status = section.querySelector('.bm-filter-status');
        if (status) status.textContent = `${count} archive selections`;
      };
      buttons.forEach(b => b.addEventListener('click', () => filter(b.dataset.bmFilter)));
      if (buttons.length) filter(location.hash.slice(1) || 'all');
    });
  }
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target.parentElement));
})();
